export var SharedModals;
(function (SharedModals) {
    SharedModals["MODAL"] = "modal";
    SharedModals["LOADER_MODAL"] = "loaderModal";
    SharedModals["UPGRADE_CONNECT_INTENT"] = "upgradeConnect";
    SharedModals["UPGRADE_PURCHASE_INTENT"] = "upgradePurchase";
    SharedModals["CREATE_SITE_CONNECT_INTENT"] = "createSiteConnect";
    SharedModals["CREATE_SITE_PURCHASE_INTENT"] = "createSitePurchase";
    SharedModals["CONNECT_DOMAIN_DISABLED"] = "connectDomainDisabled";
    SharedModals["TRANSFER_RECOMMEND_MODAL"] = "transferRecommendModal";
    SharedModals["SITE_SELECTOR_MODAL"] = "siteSelectorModal";
    SharedModals["GENERIC_MESSAGE_MODAL"] = "genericMessageModal";
    SharedModals["CHECKOUT_MODAL"] = "checkoutModal";
    SharedModals["GENERIC_TECHNICAL_ERROR_MODAL"] = "genericTechnicalErrorModal";
    SharedModals["AVAILABLE_EXTENSIONS_MODAL"] = "availableExtensionsModal";
})(SharedModals || (SharedModals = {}));
//# sourceMappingURL=types.js.map